<template>
  <BModal
    id="modal-confirm-rejection"
    hide-footer
    hide-header
    :centered="true"
    content-class="rounded-lg"
  >
    <div class="text-center p-1">
      <img
        src="https://storage.googleapis.com/komerce/core/icon-popup-warning.png"
        alt="Konfirmasi"
        class="mx-auto"
        width="80px"
      >
      <div class="font-semibold text-[18px] text-[#333333] my-2">
        Tolak Pengajuan WL?
      </div>
      <div class="mb-2">
        <p>Silahkan isi alasan penolakan pembuatan akun WL partner</p>
      </div>
      <div class="mb-2 text-left">
        <BFormTextarea
          v-model="rejectionReason"
          placeholder="Ketik alasan penolakan disini"
          class="mb-1"
          rows="3"
        />
      </div>
      <div class="flex flex-row gap-6">
        <BButton
          variant="outline-primary"
          class="rounded grow"
          @click="$bvModal.hide('modal-confirm-rejection')"
        >
          Batal
        </BButton>

        <BButton
          variant="primary"
          class="rounded grow"
          :disabled="!rejectionReason"
          @click="confirmRejection"
        >
          Tolak
        </BButton>
      </div>
    </div>
  </BModal>
</template>

<script>
export default {
  name: 'ModalConfirmRejection',
  props: {
    /**
     * Initial rejection reason value
     */
    initialReason: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      rejectionReason: this.initialReason,
    }
  },
  watch: {
    initialReason(newVal) {
      this.rejectionReason = newVal
    },
  },
  methods: {
    /**
     * Emits an event to the parent component to confirm the rejection.
     */
    confirmRejection() {
      this.$emit('confirm-rejection', this.rejectionReason)
      this.$bvModal.hide('modal-confirm-rejection')
      this.rejectionReason = ''
    },
  },
}
</script>
